<template>
  <v-container style="padding-top:5vh; padding-bottom:5vh;" id="about">
    <v-row justify="center" align="stretch" class="left" dense>
      
      <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
        <v-img src="/img/imageTwo.jpeg" style="height:100%" />
      </v-col>

      <v-col
        cols="12" xs="12" md="7" offset="1"
        class="text-left"
      >
        <p
          class="text-h6 text-md-h4 black--text font-weight-medium"
        >
          Meet Haider Baig
        </p>

        <p
          class="text-subtitle-1 black--text workSans"
        >
          Hi, I'm Haider, a Personal Trainer, Nutrition Coach and Strength
          Coach.
        </p>

        <p
          class="text-subtitle-1 black--text workSans"
        >
          Each person is unique and when it comes to training and nutrition
          there is 'No one size fits all' fitness or diet plan. We provide
          each of our clients with customised services to ensure that they
          achieve their fitness goals faster and with maximum results.
        </p>

        <p class="text-subtitle-1 black--text font-weight-bold workSans">
          Additional Certifications
        </p>

        <ul>
          <li v-for="(certification, k) in certifications" :key="k">
            <p class="text-subtitle-1 black--text workSans">
              {{ certification }}
            </p>
          </li>
        </ul>

        <p class="text-subtitle-1 black--text font-weight-bold workSans">
          Education
        </p>

        <p class="text-subtitle-1 black--text workSans">
          DES Law College B.Com, LLB
        </p>

        <p class="text-subtitle-1 black--text font-weight-bold workSans">
          Areas of expertise
        </p>

        <p class="text-subtitle-1 black--text workSans">
          Strength training, weight loss, nutrition coaching, wellness,
          mobility, new to fitness
        </p>

        <p class="text-subtitle-1 black--text font-weight-bold workSans">
          Locations
        </p>

        <v-btn outlined small @click="goToWindow('https://goo.gl/maps/21GpubRceCawBMpt5')" >
          <v-icon>mdi-google-maps</v-icon> Live Fit
        </v-btn>

        <v-btn outlined small @click="goToWindow('https://goo.gl/maps/tGoW8UNcWzTNipq16')" style="margin-left:2vw">
          <v-icon>mdi-google-maps</v-icon> ABC Fitness Hub
        </v-btn>

        <p class="text-subtitle-1 black--text font-weight-bold workSans mt-4">
          Connect
        </p>

        <v-row>
          <v-col
            cols="2" xs="2" md="1"
            v-for="(social, k) in socials"
            :key="k"
          >
            <v-btn
              fab
              color="#000"
              small
              v-on:click="goToWindow(social.link)"
            >
              <v-icon color="#fff">{{ social.icon }}</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>


<script>
// @ is an alias to /src

export default {
  name: "Home",
  components: {
    //
  },
  data: () => ({
    certifications: [
      "INFS Diploma in Fitness & Nutrition",
      "NESTA Master Personal Trainer",
      "NESTA Certified Personal Trainer",
      "Gold's Gym Certified Personal Trainer",
      "NESTA Functional Training Specialist",
      "Precision Nutrition Certified L1 Coach",
      "K11 Certified Sports Nutritionist",
      "NESTA Fitness Nutrition Specialist",
      "NESTA Sports Nutrition Specialist",
      "ZUMBA Certified SBZ Instructor",
      "NESTA Bio-mechanics Specialist",
      "NESTA Underground Strength Coach",
      "NESTA Core Conditioning Specialist",
      "NASM Mental Toughness Specialist",
      "NESTA PURSUIT Coach",
      "NESTA Metabolic Conditioning Coach",
      "NESTA Speed, Agility and Quickness Coach",
      "Red Cross Society CPR Certified",
      "NESTA Physique & Figure Training Specialist"
    ],
    socials: [
      {
        icon: "mdi-gmail",
        link: "mailto:livefit.3491@gmail.com"
      },
      {
        icon: "mdi-facebook",
        link: "https://www.facebook.com/livefit3491"
      },
      {
        icon: "mdi-instagram",
        link: "https://www.instagram.com/livefit___"
      },
      {
        icon: "mdi-linkedin",
        link: "https://www.linkedin.com/in/haider-baig-032274181"
      }
    ],
    goToWindow(link) {
      window.open(link, "_blank");
    },
  }),
  methods: {
    //
  }
};
</script>



<style>
.workSansLight{
  font-family: 'Work Sans', sans-serif !important;font-weight:400;font-style: normal;
}

.workSans{
  font-family: 'Work Sans', sans-serif !important;font-weight:700;font-style: normal;
}

.playFair{
  font-family: 'Playfair Display', serif !important;font-weight:700; font-style:italic;
}


</style>
